import React from 'react';
import ProfilePicker from '../ProfilePicker';
import ProfileData from '../ProfileData';
import Calculation from './DCalc';
import ProfileViewer from './ProfileViewer';
import './Durchbiegung.css';

function Calculator() {
  return (
    <>
      <div className='Container'>
        <div className='Calc'>
          <Calculation />
        </div>
        <div className='Picker'>
          <ProfilePicker />
        </div>
        <div className='Data'>
          <ProfileData />
        </div>
        <div className='Viewer'>
          <ProfileViewer />
        </div>
      </div>
    </>
  );
}

export default Calculator;
